import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Input,
  Output,
  OnInit,
} from '@angular/core';

import { AudioState, IAudioState } from '@models/audio-state';
import {
  FormattedKaraokePlayer,
  IFormattedKaraokePlayer,
  IKaraokePlayer,
  KaraokePlayer,
} from '@models/grade-unit/karaoke';

@Component({
  selector: 'app-karaoke-player-presentation',
  templateUrl: './karaoke-player-presentation.component.html',
  styleUrls: ['./karaoke-player-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KaraokePlayerPresentationComponent {
  @Input() public audio: IAudioState = new AudioState();
  @Input() public currentTime: number = 0;
  @Input()
  public karaoke: IFormattedKaraokePlayer = new FormattedKaraokePlayer();

  @Output() public emitPause = new EventEmitter<void>();
  @Output() public emitLoadAndPlay = new EventEmitter<void>();
  @Output() public emitRestart = new EventEmitter<void>();
  @Output() public emitResume = new EventEmitter<void>();
  @Output() public emitStop = new EventEmitter<void>();

  public loadAndPlay(): void {
    this.emitLoadAndPlay.emit();
  }

  public pause(): void {
    this.emitPause.emit();
  }

  public restart(): void {
    this.emitRestart.emit();
  }

  public resume(): void {
    this.emitResume.emit();
  }

  public stop(): void {
    this.emitStop.emit();
  }

  public showPromptImage() {
    return this.karaoke?.transcriptWordList?.some(
      (word) =>
        word.isBlue || word?.wordList?.some((subword) => subword.isBlue),
    );
  }
}
